import { licensedTerritoryForGameId } from './highFrequencyTerritory'

type MaybeOrder<TOrder> = TOrder | null | undefined

type HighFrequencyReplayableOrder = {
  gameId?: string
  orderedIn?: string
  replayable: boolean
}

export const canReplayHighFrequencyOrder = (
  order: MaybeOrder<HighFrequencyReplayableOrder>,
  activeLicensedTerritory: string,
): boolean => {
  if (!order?.replayable) return false

  const orderTerritory = order.orderedIn ?? licensedTerritoryForGameId(order.gameId)

  if (!orderTerritory) return true

  return orderTerritory === activeLicensedTerritory
}

type LotteryReplayableOrder = {
  replayable: boolean
}

export const canReplayLotteryOrder = (order: MaybeOrder<LotteryReplayableOrder>): boolean =>
  !!order?.replayable
